import moment from "moment";

export const studioStatuses = {
  "UNVERIFIABLE_PENDING_VALIDATE": "validation.status.UNVERIFIABLE_PENDING_VALIDATE",
  "VALIDATED": "validation.status.CERTIFIED",
  "UNVERIFIABLE": "validation.status.UNVERIFIABLE"
};

export const studioStatusColors = {
  "UNVERIFIABLE_PENDING_VALIDATE": "var(--status-warning)",
  "VALIDATE": "rgb(73, 74, 76)",
  "UNVERIFIABLE": "var(--status-alert2)"
};

const officeInitials = {
  1: "OWNR",
  2: "LEGL",
  3: "PROS"
};

export const corporateOfficeDescription = {
  1: "validation.officesDoc.1",
  2: "validation.officesDoc.2",
  3: "validation.officesDoc.3"
};

export const prepareValidationDocument = (body, data) => { 
  const address = data?.additionalData?.details?.addresses?.find(x => x?.types?.indexOf("REGISTERED_OFFICE") > -1);
  if (!address){
    return null;
  }
  const beforeToday = !moment().diff(body?.date) > 0;
  return {
    "firstName": body.name,
    "lastName": body.surname,
    "companyName": data.ragioneSociale,
    "documentPlace": body.city,
    "documentDate": body?.date.format("YYYY-MM-DD") + `T${beforeToday ? "00:00:00.000" : moment().format("HH:MM:ss.SSS")}Z`,
    "role": officeInitials[body.office] || "OWNR",
    "notificationConsent": body.consent1 === "yes",
    "thirdPartyNotificationConsent": body.consent2 === "yes",
    "streetName": address.streetName,
    "streetNumber": address.streetNumber,
    "city": address.city,
    "province": address.province,
    "zipCode": address.zipCode,
    "country": address.country,
    "fullAddress": address.fullAddress,
    "types": address.types,
    "id": address.id,
    "name": body.name,
    "surname": body.surname,
    "corporateOffice": corporateOfficeDescription[body.office] || corporateOfficeDescription[1],
    "taxId": data.codiceFiscale,
    "pIva": data.partitaIva,
    "description": data.ragioneSociale,
    "date": body?.date.format("YYYY-MM-DD") + `T${beforeToday ? "00:00:00.000" : moment().format("HH:MM:ss.SSS")}Z`,
    "place": body.city
  };
};